<template>
  <div id="app">
    <div class="logo-container">
      <img alt="Vue logo" src="./assets/itadakimonster-logo.png">
    </div>
    <div id="nav">
      <router-link to="/login">Login</router-link>
      <router-link to="/dashboard">Dashboard</router-link>
      <router-link to="/home">Reviews</router-link>
      <router-link to="/comment">Comments</router-link>
      <router-link to="/users">Users</router-link>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.logo-container {
  width: 200px;
  height: 200px;
  margin: 0 auto;

}
img {
    border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue